import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum TariffTypes {
  FREE,
  PROMO,
  REGULAR,
}

export enum TariffStatusType {
  INACTIVE,
  ACTIVE,
  CANCELED,
  EXPIRED,
}

export interface ITariffToolData {
  name: string;
  tool_name: string;
  tool_description: string | null;
  limit?: number | null;
}

export interface ITariff {
  id: string;
  name: string;
  type: number;
  duration_days: number | 'unlimit';
  description_1: string;
  description_2: string;
  start_date: Date;
  end_date: Date;
  price: number;
  currency_symbol: string;
  currency_code: string;
  purchase_once: boolean;
  discount: number;
  discountDurationDays: number;
  is_bonus_payment_available: boolean;
  bonus_payment_limit_percent: number;
  is_popular: boolean;
  auto_renew: boolean;
  tool_names: string[];
  tool_labels: string[];
  tools_data: ITariffToolData[];
  status: number;
  created_at: Date;
  base_duration: number;
  base_price: number;
  base_discount: number;
  updated_at: Date;
  sort?: number;
  package_type?: string;
  validity_days?: number | null;
}

interface ITariffState {
  tariffs: ITariff[];
  tariffsToolsMaxCount: number;
  current: ITariff[];
  scheduled: ITariff[];
}

const initialState: ITariffState = {
  tariffs: [],
  tariffsToolsMaxCount: 0,
  current: [],
  scheduled: [],
};

export const tariffSlice = createSlice({
  name: 'tariff',
  initialState,
  reducers: {
    setTariffs: (state, action: PayloadAction<ITariff[] | []>) => {
      state.tariffs = action.payload;
    },
    setActiveTariffs: (state, action: PayloadAction<ITariff[] | []>) => {
      state.current = action.payload;
    },
    setScheduledTariffs: (state, action: PayloadAction<ITariff[] | []>) => {
      state.scheduled = action.payload;
    },
    setTariffsMaxToolsCount: (state, action: PayloadAction<number>) => {
      state.tariffsToolsMaxCount = action.payload;
    },
  },
});

export const { setTariffs, setActiveTariffs, setScheduledTariffs, setTariffsMaxToolsCount } = tariffSlice.actions;
export default tariffSlice.reducer;
